import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './QuoteStatus.css';

class QuoteStatus extends Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className="quote-status">
        <div>
          {this.props.status.charAt(0).toUpperCase() +
            this.props.status.slice(1)}
        </div>
        <div className={'status ' + this.props.status} />
      </div>
    );
  }
}

export default QuoteStatus;



// WEBPACK FOOTER //
// ./src/components/shared/table/cell-addons/QuoteStatus.js